import PaymentManager from 'services/PaymentManager'
import UserManager from 'services/UserManager'
import StorageManager from 'services/StorageManager'
import {
  ACTIVE_ORDERS_COUNT_KEY,
  IS_NEW_ACCOUNT_KEY,
} from 'services/LoginUtills'
import { giftNoteManager } from 'services/GiftNoteManager'
import { promoCodeManager } from 'services/PromoCodeManager'
import { clearPendingArrival } from 'features/bookArrivalNotice/pendingArrivalStorage'
import { clearCartUpsellRecords } from 'features/cartUpsells/cartUpsellsStorage'
import {
  getAddressStore,
  getPhotoBankStore,
  getPhotoBooksStore,
  getTilesStore,
} from 'stores/RootStoreProvider'

export function clearSignedOutUserData(): void {
  PaymentManager.clearData()
  getAddressStore().clearData()
  UserManager.clearData()
  getTilesStore().clearMemoryAndStorage()
  StorageManager.remove(ACTIVE_ORDERS_COUNT_KEY)
  StorageManager.remove(IS_NEW_ACCOUNT_KEY)
  giftNoteManager.clearData()
  promoCodeManager.clearDiscountCoupon()
  getPhotoBankStore().clearMemoryAndStorage()
  getPhotoBooksStore().clearAllBooks()
  clearCartUpsellRecords()
  // Logout redirects rather than reloading, so a notice still waiting for the
  // editor would outlive the books it announces.
  clearPendingArrival()
}
